
export interface Bloco {
    id: string;
    nome: string | null;
    descricao?: string | null;
}

export const ISbloco: Bloco = {
    id: "",
    nome: "",
    descricao: "",
}